import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getWebinarDetail} from "../helper";
import { useLivePreviewCtx } from "../context/live-preview-context-provider";
import { WebinarRes } from "../typescript/pages";
import styles from "../styles/WhitePaper.module.css";
import HeroBanner from "../components/hero-banner";
import { HeroBanner as HeroBannerProp } from "../typescript/components";
import HeroTitle from "../components/hero-title";
import {
  EntryProps,
  HeroTitle as HeroTitleProp,
} from "../typescript/components";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import {
    EmailShareButton,
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
} from "react-share";
export default function Webinar({
  entry,
}: {
  entry: ({ page }: EntryProps) => void;
}) {
  const lpTs = useLivePreviewCtx();
  const { webinarId } = useParams();
  const [getEntry, setEntry] = useState({
    webinar: {} as WebinarRes,
  });
  const [error, setError] = useState(false);
  const { i18n } = useTranslation();
  async function fetchData() {
    try {
      const entryUrl = webinarId
        ? `/resources/webinar/${webinarId}`
        : "/";
      const webinar = await getWebinarDetail(entryUrl);
      if (!webinar) setError(true);
      setEntry({ webinar });
      entry({ webinar: [webinar] });
    } catch (error) {
      console.error(error);
      setError(true);
    }
  }

  useEffect(() => {
    fetchData();
    //if (error) history(`/${i18n.language}/404`);
  }, [webinarId, lpTs, error, i18n.language]);

  const { webinar } = getEntry;

  const heroBannerData = {
    banner_eyebrow: "WEBINAR",
    banner_title: webinar.title,
    banner_title_alt: "",
    display_options: {
      align_image: "Right",
      align_text: "Left",
      background_color: "Light",
      breadcrumb: true,
      show_button: false,
      split_50_50: true,
    },
    header_tag_type: "H1",
    banner_media: webinar.featured_image,
  } as HeroBannerProp;

  const heroTitleData = {
    align_text: "Left",
    bottom_border: true,
    content: "",
    eyebrow: "WEBINAR",
    header_tag_type: "H1",
    show_breadcrumb: true,
    title: webinar.title,
  } as HeroTitleProp;

  const meta_title = webinar?.seo?.meta_title;
  const meta_description = webinar?.seo?.meta_description;
    const keywords = webinar?.seo?.keywords;

    const brand = process.env.REACT_APP_CONTENTSTACK_BRAND as string;

    if (brand === "dynacast") {
        webinar.form_url = "https://go.formtechnologies.com/l/682843/2024-11-15/2cl51f?Resource_Type=Webinar&Resource_Title=/" + i18n.language + webinar.url + "&Language=" + i18n.language;
    } else if (brand === "signicast") {
        webinar.form_url = "https://go.formtechnologies.com/l/682843/2024-11-15/2cl51m?Resource_Type=Webinar&Resource_Title=/" + i18n.language + webinar.url + "&Language=" + i18n.language;
    } else if (brand === "optimim") {
        webinar.form_url = "https://go.formtechnologies.com/l/682843/2024-11-15/2cl58t?Resource_Type=Webinar&Resource_Title=/" + i18n.language + webinar.url + "&Language=" + i18n.language;
    }
    const canonicalUrl = `${window.location.origin}${window.location.pathname}`;

  return (
    <>
      <Helmet>
        {meta_title && <title>{meta_title}</title>}
        {meta_description && (
          <meta name="description" content={meta_description} />
        )}
        {keywords && <meta name="keywords" content={keywords} />}
              <meta name="robots" content="index, follow" />
              <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      <div className={styles.outerWrapper}>
        {webinar.featured_image && webinar.featured_image.url ? (
          <HeroBanner
            key="contactPageTitle"
            hero_banner={heroBannerData}
          ></HeroBanner>
        ) : (
          <HeroTitle
            key="contactPageTitle"
            hero_title={heroTitleData}
          ></HeroTitle>
        )}
        <div className={styles.moduleWrapper}>
          <div className={styles.root}>
                      <section className={styles.virtualTour}>
                          <div className={styles.socialWrapper}>
                              <LinkedinShareButton url={window.location.href} className="Demo__some-network__share-button">
                                  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path xmlns="http://www.w3.org/2000/svg" id="Vector" fillRule="evenodd" clipRule="evenodd" d="M0.115235 1.73562C0.115235 1.28877 0.292743 0.860227 0.608711 0.54426C0.924679 0.228292 1.35322 0.0507835 1.80007 0.0507835H18.5952C18.8167 0.0504218 19.036 0.0937412 19.2407 0.178261C19.4454 0.262781 19.6314 0.386842 19.7881 0.543342C19.9447 0.699841 20.069 0.885705 20.1537 1.09029C20.2385 1.29488 20.282 1.51417 20.2819 1.73562V18.5308C20.2821 18.7523 20.2387 18.9716 20.1541 19.1763C20.0695 19.381 19.9453 19.567 19.7888 19.7237C19.6322 19.8803 19.4463 20.0046 19.2416 20.0893C19.037 20.174 18.8176 20.2176 18.5962 20.2175H1.80007C1.57874 20.2175 1.35957 20.1738 1.1551 20.0891C0.950625 20.0044 0.76485 19.8802 0.608387 19.7237C0.451924 19.5671 0.327839 19.3813 0.243222 19.1767C0.158605 18.9722 0.115114 18.753 0.115235 18.5317V1.73562ZM8.09757 7.73978H10.8283V9.11112C11.2225 8.32278 12.2308 7.61328 13.7461 7.61328C16.651 7.61328 17.3394 9.18353 17.3394 12.0646V17.4015H14.3997V12.721C14.3997 11.0801 14.0055 10.1543 13.0045 10.1543C11.6157 10.1543 11.0382 11.1525 11.0382 12.721V17.4015H8.09757V7.73978ZM3.0559 17.2759H5.99657V7.61328H3.0559V17.275V17.2759ZM6.41732 4.46178C6.42286 4.71357 6.37806 4.96392 6.28554 5.19816C6.19302 5.43239 6.05464 5.64578 5.87853 5.82581C5.70242 6.00584 5.49213 6.14888 5.25999 6.24654C5.02785 6.3442 4.77854 6.3945 4.52669 6.3945C4.27485 6.3945 4.02554 6.3442 3.7934 6.24654C3.56126 6.14888 3.35097 6.00584 3.17486 5.82581C2.99875 5.64578 2.86037 5.43239 2.76785 5.19816C2.67533 4.96392 2.63052 4.71357 2.63607 4.46178C2.64695 3.96757 2.85092 3.49726 3.2043 3.15158C3.55767 2.8059 4.03236 2.61233 4.52669 2.61233C5.02103 2.61233 5.49572 2.8059 5.84909 3.15158C6.20247 3.49726 6.40644 3.96757 6.41732 4.46178Z" fill="var(--primary-500)" />
                                  </svg>
                              </LinkedinShareButton>
                              <TwitterShareButton
                                  url={window.location.href}
                                  title={heroTitleData?.title}
                                  className="Demo__some-network__share-button">
                                  <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path id="Vector" d="M13.2917 9.42426L21.4817 0H19.5409L12.4296 8.18295L6.74974 0H0.19873L8.78775 12.3741L0.19873 22.2569H2.13961L9.6494 13.6154L15.6477 22.2569H22.1987L13.2912 9.42426H13.2917ZM10.6334 12.4831L9.76318 11.2509L2.83893 1.44634H5.82L11.4079 9.35894L12.2782 10.5911L19.5419 20.8763H16.5608L10.6334 12.4836V12.4831Z" fill="var(--primary-500)" />
                                  </svg>

                              </TwitterShareButton>
                              <FacebookShareButton url={window.location.href} className="Demo__some-network__share-button">
                                  <svg width="13" height="23" viewBox="0 0 13 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path id="Vector" d="M11.3179 12.5092L11.9291 8.52789H8.10868V5.94426C8.10868 4.85526 8.64218 3.79307 10.3534 3.79307H12.09V0.4037C12.09 0.4037 10.5142 0.134888 9.00724 0.134888C5.86124 0.134888 3.80493 2.04201 3.80493 5.49395V8.52857H0.307617V12.5099H3.80493V22.1349H8.10868V12.5099L11.3179 12.5092Z" fill="var(--primary-500)" />
                                  </svg>

                              </FacebookShareButton>
                              <EmailShareButton
                                  url={window.location.href}
                                  subject={heroTitleData?.title}
                                  body="body"
                                  className="Demo__some-network__share-button">
                                  <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path id="Vector" d="M7.36541 15.2217L5.74291 16.7984C5.31746 17.2238 4.74042 17.4628 4.13874 17.4628C3.53706 17.4628 2.96003 17.2238 2.53458 16.7984C2.10913 16.3729 1.87011 15.7959 1.87011 15.1942C1.87011 14.5925 2.10913 14.0155 2.53458 13.59L6.69624 9.4192C7.10472 9.0094 7.6551 8.77229 8.23351 8.75693C8.81192 8.74158 9.3741 8.94915 9.80374 9.3367L9.91374 9.42837C10.0876 9.59855 10.3219 9.69271 10.5651 9.69013C10.8084 9.68755 11.0406 9.58845 11.2108 9.41462C11.381 9.24079 11.4752 9.00648 11.4726 8.76323C11.47 8.51998 11.3709 8.28772 11.1971 8.11753C11.1453 8.05064 11.0903 7.98639 11.0321 7.92503C10.2496 7.24424 9.23755 6.88631 8.20101 6.92376C7.16448 6.9612 6.18092 7.39122 5.44958 8.1267L1.23291 12.2975C0.516403 13.0774 0.128895 14.104 0.151312 15.1628C0.173728 16.2216 0.604335 17.2309 1.35321 17.9797C2.10208 18.7286 3.11131 19.1592 4.17014 19.1816C5.22896 19.2041 6.25552 18.8165 7.03541 18.1L8.62124 16.5509C8.77783 16.38 8.8639 16.1563 8.86215 15.9245C8.8604 15.6928 8.77096 15.4704 8.61181 15.3019C8.45267 15.1335 8.23564 15.0316 8.00439 15.0167C7.77314 15.0018 7.54483 15.0751 7.36541 15.2217ZM17.1646 2.16837C16.3935 1.40204 15.3505 0.971924 14.2633 0.971924C13.1762 0.971924 12.1332 1.40204 11.3621 2.16837L9.77624 3.71753C9.61966 3.88836 9.53359 4.11214 9.53534 4.34386C9.53709 4.57558 9.62653 4.79804 9.78568 4.96648C9.94482 5.13492 10.1618 5.23683 10.3931 5.25171C10.6243 5.2666 10.8527 5.19335 11.0321 5.0467L12.6179 3.47003C13.0434 3.04458 13.6204 2.80557 14.2221 2.80557C14.8238 2.80557 15.4008 3.04458 15.8262 3.47003C16.2517 3.89549 16.4907 4.47252 16.4907 5.0742C16.4907 5.67588 16.2517 6.25292 15.8262 6.67837L11.6646 10.8492C11.2561 11.259 10.7057 11.4961 10.1273 11.5115C9.5489 11.5268 8.98672 11.3193 8.55708 10.9317L8.44708 10.84C8.27325 10.6699 8.03894 10.5757 7.79569 10.5783C7.55244 10.5809 7.32017 10.68 7.14999 10.8538C6.97981 11.0276 6.88565 11.2619 6.88823 11.5052C6.89081 11.7484 6.98992 11.9807 7.16374 12.1509C7.23033 12.219 7.30072 12.2832 7.37458 12.3434C8.15803 13.0221 9.16962 13.3787 10.2055 13.3413C11.2414 13.3039 12.2246 12.8752 12.9571 12.1417L17.1279 7.97087C17.8991 7.2046 18.3358 6.16433 18.3427 5.07718C18.3496 3.99003 17.9261 2.94432 17.1646 2.16837Z" fill="var(--primary-500)" />
                                  </svg>

                              </EmailShareButton>
                          </div>
              <div
                className={styles.description}
                dangerouslySetInnerHTML={{
                  __html: webinar.content,
                }}
              />
                      </section>
                      {webinar.form_url && (
                          <>
                              <div className={styles.divider} />
                              <div className={styles.taxonomyWrapper}>
                                  <iframe
                                      src={webinar.form_url}
                                      title="Contact Form"
                                      className={styles.iframe}
                                  />
                              </div>
                          </>
                      )}
          </div>
        </div>
      </div>
    </>
  );
}
